class QuickBookProperty {
    constructor(panel = null) {
        if(panel == null) return false;
        this.property = panel.querySelector('.js-booking-properties') ?? false;
        if(!this.property) return;
        this.location_dropdown = this.property.querySelector('.js-location-dropdown');
        this.location_radio = this.property.querySelector('.js-location-radio');
        this.property_dropdown = this.property.querySelector('.js-propery-dropdown');
        this.property_radio = this.property.querySelector('.js-property-radio');
        this.quick_book_map = new QuickBookMap(panel);
        this.variation = panel.dataset.variation;
        this.property_variation = this.property.dataset.variation;
        this.location_id;
        
        this.getRoomsByLocation();
    }

    getRoomsByLocation() {
        var _self = this;
        _self.locationDropdown();
        _self.propertyDropdown();
        _self.locationRadio();
        _self.propertyRadio();
    }

    locationRadio() {
        var _self = this,
            location = _self.location_radio;
            
        if(!location) return;
        const radio_buttons = location.querySelectorAll('input[name="voyager_booking_location"]')       
        radio_buttons.forEach(element => {
            element.addEventListener('change', function(e) {
                _self.location_id = e.target.dataset.id;
                _self.togglePropertyList(_self.location_id);
                if(!_self.property_radio) return;
                const properties = _self.property_radio.querySelectorAll('li');
                _self.allProperty(properties)
            })
        });
    }

    propertyRadio() {
        var _self = this,
            property = _self.property_radio;

        if(!property) return;

        const radio_buttons = property.querySelectorAll('input[name="voyager_booking_property"]');

        radio_buttons.forEach(element => {
            element.addEventListener('change', function(e) {
                var property_id = e.target.dataset.id;
                _self.quick_book_map.selectMapListByID(property_id);
            })
        })
    }         

    locationDropdown() {
        var _self = this,
            location = _self.location_dropdown;

        if(!location) return;   
       
        location.addEventListener('change', function(e) {
            _self.location_id = location.options[location.selectedIndex].dataset.id;
            _self.togglePropertyList(_self.location_id);
            if(!_self.property_dropdown) return;
            const properties = _self.property_dropdown.querySelectorAll('option');
            _self.allProperty(properties);
        })
    }

    propertyDropdown() {
        var _self = this,
            property = _self.property_dropdown;
        if(!property) return;

        property.addEventListener('change', function() {
            var property_id = property.options[property.selectedIndex].dataset.id;
            _self.quick_book_map.selectMapListByID(property_id);
        })
    }

    selectProperty(id) {
        var _self = this;
        _self.selectDropdown('.js-location-dropdown', id)
        _self.selectDropdown('.js-propery-dropdown', id)
        _self.selectRadio('.js-location-radio', id)
        _self.selectRadio('.js-property-radio', id)
    }

    selectRadio(elements, id) {
        elements = document.querySelector(elements);
        if(!elements) return;
        elements.querySelectorAll('input').forEach(element => {
            if (element.dataset.id === id.toString()) {
                element.checked = true;
            } else {
                element.checked = false;
            }
        });
    }

    selectDropdown(elements, id) {
        elements = document.querySelector(elements);
        if(!elements) return;
        elements.querySelectorAll('option').forEach(element => {
            if (element.dataset.id === id.toString()) {
                element.selected = true;
            } else {
                element.selected = false;
            }
        });
    }

    togglePropertyList(id) {
        var _self = this;

        if (_self.variation === 'option_4') {
            if (_self.property_variation === 'location_property' || 
                (_self.property_variation === 'location_taxonomy' && _self.property.dataset.separation)) {
                _self.quick_book_map.handleItems(id);
            } else if (_self.property_variation === 'location_taxonomy' || 
                    _self.property_variation === 'location_property_location') {
                _self.quick_book_map.selectMapListByID(id);
            }
        }
    }

    allProperty(ele) {
        var _self = this;
        ele.forEach(element => {
            _self.get_property_by_location_id(element)
        })
    }

    get_property_by_location_id(element) {
        var _self = this,
            location_id = element.dataset.parentId;;
        element.selected = false;   
        if(element.querySelector('input')) {
            element.querySelector('input').checked = false;    
        }
        _self.quick_book_map.selectMapListByID('all');
        if(_self.location_id) {        
            if(location_id === 'all' || _self.location_id === 'all' || location_id === _self.location_id) {
                element.style.display = "";
            } else {
                element.style.display = "none";
            }
        } else {
            element.style.display = "";
        } 
    }

    openMapwithPropery() {
        var _self = this;
        if(_self.variation === 'option_4') {
            _self.quick_book_map.getPropertyList();
        }
    }

    getPropertyQuery() {
        var _self = this,
            variation = _self.property.dataset.variation;
        // if(variation === 'location_property' || variation === 'location_property_location') {
            return _self.getVariationLocationPropertyQuery();
        // } else if(variation === 'location_taxonomy') {
        //     return _self.getVariationLocationTaxonomyQuery();
        // }
    }

    getVariationLocationPropertyQuery() {
        var _self = this,
            location_query = false,
            property_query = false;

        if(_self.location_dropdown) {
            location_query = _self.elementDropdown(_self.location_dropdown)
        } else if(_self.location_radio) {
            location_query = _self.elementRadio(_self.location_radio);
        }

        if(_self.property_dropdown) {
            property_query = _self.elementDropdown(_self.property_dropdown);
        } else if(_self.property_radio) {
            property_query = _self.elementRadio(_self.property_radio);
        }

        if(property_query) {
            return property_query;
        } else if(location_query) {
            return location_query;
        } else {
            return false;
        }
    }

    getVariationLocationTaxonomyQuery() {
        var _self = this,
            location_query = _self.elementDropdown(_self.location_dropdown);
            
        if(location_query) {
            return location_query;
        } else {
            return false;
        }
    }

    elementDropdown(element) {
        if(!element) return false;
        var _self = this,
            selected_index = element.options.selectedIndex,
            data_set = element.options[selected_index].dataset,
            element_value = element.options[selected_index].value;

        return _self.setQueryString(selected_index, data_set, element_value);
    } 

    elementRadio(element) {
        if(!element) return false;
        var _self = this,
            element = element.querySelectorAll('input[type="radio"]'),
            selected_index,
            data_set,
            element_value;
        
        if(element) {
            element.forEach((radio, i) => {
                if(radio.checked) {
                    selected_index = i;
                    data_set = radio.dataset;
                    element_value = radio.value;
                }
            });

            return _self.setQueryString(selected_index, data_set, element_value);
        } else {
            return false;
        }
    }

    setQueryString(selected_index, data_set, element_value) {
        if(selected_index && selected_index !== 0) {
            var keywords = '';
            if(data_set.keyword) {
                var amp = '';
                data_set.keyword.split(',').forEach((element, i) => {
                    if(i !== 0) {
                        amp = '&';
                    }
                    keywords += amp +'keywords[]='+ element.trim();
                });
            }

            return element_value;
        } else {
            return false;
        }
    }

}